import { render, staticRenderFns } from "./RightWrap2.vue?vue&type=template&id=78da4034&scoped=true"
import script from "./RightWrap2.vue?vue&type=script&lang=js"
export * from "./RightWrap2.vue?vue&type=script&lang=js"
import style0 from "./RightWrap2.vue?vue&type=style&index=0&id=78da4034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78da4034",
  null
  
)

export default component.exports